import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import logo from "../../assets/logo.jpg"
import './Career.css'

export default function Career() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [urgentJobs, setUrgentJobs] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [allJobsOpennings, setAllJobsOpennigs] = useState([])

  useEffect(() => {
    fetch("/Json/Career/Carrer.json")
      .then((res) => res.json())
      .then((data) => {
        setUrgentJobs(data.urgentrequirement)
        setDepartments(data.departments)
        setAllJobsOpennigs(data.alljobsopennings)
      })
      .catch((err) => console.error("Failed to load job data:", err));
  }, []);

  const handleApplyClick = (job) => {
    navigate('/career/apply', { 
      state: { 
        job: job,
        from: 'career-listing'
      } 
    });
  };

  const filteredJobs = selectedCategory
    ? allJobsOpennings.filter(job => job.category === selectedCategory)
    : allJobsOpennings;

  return (
    <div style={{fontFamily:"Montserrat-Regular"}}>
      {/* HERO SECTION */}
      <div className="hero-container">
        <h1 className="hero-heading">Get The Right Job <br /> You Deserve</h1>
        <div className="search-bar-wrapper">
          <div className="search-bar">
            <input type="text" placeholder="Job title or keyword" />
            <input type="text" placeholder="Hyderabad, India" disabled />
            <button className="search_button">Search</button>
          </div>
        </div>
      </div>

      {/* URGENT JOBS */}
      <section className="py-5">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark">Urgent Requirement</h2>
            <Link to="#" className="text-primary text-decoration-none">See All Jobs</Link>
          </div>
          {urgentJobs && (
            <div className="row">
              {urgentJobs.map((job, idx) => (
                <div className="col-lg-4 mb-4" key={idx}>
                  <div className="card h-100 border-0 shadow-sm" style={{ backgroundColor: job.bgColor }}>
                    <div className="card-body p-4">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h5 className="card-title fw-bold text-dark mb-1">{job.jobtitle}</h5>
                          <div className="d-flex align-items-center">
                            <span className="text-muted me-2">{job.companyName}</span>
                            <span className="badge bg-primary rounded-circle" style={{ width: "8px", height: "8px" }}></span>
                          </div>
                        </div>
                        <div className="bg-primary text-white p-2 rounded" style={{ fontSize: "12px" }}>
                          {job.experience}
                        </div>
                      </div>
                      <p className="text-muted small mb-3">{job.shortDesc}</p>
                      <div className="d-flex align-items-center text-muted small mb-3">
                        <span>{job.jobLoc} | {job.jobType}</span>
                      </div>
                      <button
                        className={`btn btn-outline-${job.btnColor || "primary"} rounded-pill px-4`}
                        onClick={() => handleApplyClick(job)}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* DEPARTMENTS */}
      <div className="bg-light py-5 mb-5 rounded">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold">Departments</h4>
          </div>
          {departments && (
            <div className="row g-3">
              {departments.map((item, index) => (
                <div className="col-6 col-md-3" key={index}>
                  <div
                    className={`d-flex align-items-center justify-content-between bg-white shadow-sm rounded-pill px-3 py-2 ${selectedCategory === item.name ? 'border border-primary' : ''}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedCategory(item.name)}
                  >
                    <i className={`bi ${item.icon} text-primary fs-5`}></i>
                    <div className="ms-2 flex-grow-1">
                      <h6 className="mb-0">{item.name}</h6>
                      <small className="text-muted">Jobs Available</small>
                    </div>
                    <i className="bi bi-chevron-right"></i>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* JOB LISTINGS */}
      <section className="py-5 container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold mb-0">
            {selectedCategory ? `${selectedCategory} Jobs` : "Current Opennings"}
          </h4>
          {selectedCategory && (
            <button className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedCategory(null)}>
              Show All
            </button>
          )}
        </div>
        <div className="row g-4 mb-5">
          {filteredJobs.length > 0 ? (
            filteredJobs.map((job) => (
              <div className="col-lg-4" key={job.id}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h5 className="card-title fw-bold text-dark mb-1">{job.title}</h5>
                        <div className="d-flex align-items-center">
                          <span className="text-muted me-2">{job.company}</span>
                        </div>
                      </div>
                      <div className="text-black p-2 rounded" style={{ fontSize: "12px" }}>
                        {job.experience}
                      </div>
                    </div>
                    <p className="text-muted small mb-3">{job.shortDesc}</p>
                    <div className="d-flex align-items-center text-muted small mb-3">
                      <span>{job.location} | {job.type}</span>
                    </div>
                    <button 
                      className="btn apply_button rounded-pill px-4"
                      onClick={() => handleApplyClick(job)}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p className="text-center text-muted">No jobs available for this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA SECTION */}
      {/* <section className="py-5" style={{ backgroundColor: "#f1f3f4" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2 className="fw-bold text-dark mb-4" style={{ lineHeight: "1.3" }}>
                Get Matched The Most Valuable Jobs, Just Drop Your CV at BluKraft
              </h2>
              <p className="text-muted mb-4">
                In the subject line of your email, write your name, the description of the position and its reference
                number. If you did not find the vacancy on the employer's website, it's helpful to state where you found
                it.
              </p>
              <button
                className="btn text-white fw-medium px-4 py-2 rounded-pill"
                style={{ backgroundColor: "#c26ab3ff" }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#411860")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#c26ab3ff")}
              >
                Register Now
              </button>
            </div>
            <div className="col-lg-6 career_form">
              <div className="card border-0 shadow-sm">
                <div className="card-header text-white text-center py-3">
                  <div className="d-flex align-items-center justify-content-center">
                    <img
                      src={logo}
                      alt="Logo"
                      className="form-logo"
                      style={{ width: "120px", height: "auto" }}
                    />
                  </div>
                </div>
                <div className="card-body p-4">
                  <form>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                        style={{ border: "1px solid #ddd", padding: "12px" }}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email"
                        style={{ border: "1px solid #ddd", padding: "12px" }}
                      />
                    </div>
                    <div className="mb-3">
                      <select className="form-select" style={{ border: "1px solid #ddd", padding: "12px" }}>
                        <option>Designation</option>
                        <option>Junior Developer</option>
                        <option>Senior Developer</option>
                        <option>Designer</option>
                        <option>Manager</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <select className="form-select" style={{ border: "1px solid #ddd", padding: "12px" }}>
                        <option>Proposal</option>
                        <option>Full-time Position</option>
                        <option>Part-time Position</option>
                        <option>Contract Work</option>
                        <option>Freelance</option>
                      </select>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  )
}
